import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';

// Material helpers
import { withRouter } from 'react-router-dom';
import Autocomplete from '@material-ui/lab/Autocomplete';
import styles from './styles';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import queryString from 'query-string';
import { withTranslation } from 'react-i18next';
const servicios = [
  { servicio: 'atWeb' , id:0, color:"#525252"},
  { servicio: 'atMobile', id:1, color:"#525252"},
  { servicio: 'atIvr', id:2, color:"#525252"},
  { servicio: 'atMeta', id:3, color:"#525252"}
]

class Filter extends Component {
  constructor(props) {
    const parsed = queryString.parse(props.location.search);
    const services = parsed?.services?.split(',') ?? []
    const selectedService = servicios.filter((tag) => {
      return services.includes(tag.servicio.toString());
    });

    super(props);
    //console.log("filter props", props)
    this.state = {
      servicios,
      selectedService,
    }
    
  }

  changeFilter = (event, value) => {
    this.props.InfoAutoComplete(value)
    this.setState({selectedService: value})
  };
  render(){
    const {servicios } =this.state
    const { classes } = this.props;
    const t = (this.props && this.props.t) ? this.props.t : (s => s)
      return (
        <div className={classes.root}>
          
          <Autocomplete
          
          multiple
          //id={option => option.id}
          options={servicios}
          getOptionLabel={option => option.servicio}
          onChange={this.changeFilter}
          renderOption={params => {
            return (
                <div style={{color:params.color}}>{params.servicio}</div>
            );
        }}
          size='small'
          renderInput={params => (
            <TextField
              //style={{color:params.color}}
              {...params}
              variant='outlined'
              label={t('text.service-filter')}
              placeholder={t('text.service')}
              fullWidth
              size='small'
            />
          )}
          value={this.state.selectedService}
        />
          
        </div>
      );
    //}
    
  }
  
}


export default compose(withRouter, withStyles(styles), withTranslation())(Filter);
